<template>
    <div class="user-preview">
        
     
        <NAvatar :image="person.personAvatar" class="ma-2"/>
        
        <p class="user-preview__name" v-if="person">
          <span v-if="person.firstname">{{ person.firstname }}</span>
          <span v-if="person.lastname">{{ person.lastname }}</span>
          <span v-if="person.secname"> {{ person.secname }}</span> 
          <span v-if="person.personEmail">({{ person.personEmail }})</span>
        </p>

    </div>
  </template>
  
  <script>

  import NAvatar from "@/elements/NAvatar.vue";
  
  import { t } from "@/utils/translate";
  
  export default {
    props: {
      person: {
        type: Object,
        required: true,
      },
    },
    setup() {
      return { t };
    },
    components: { NAvatar },
  };
  </script>
  
  <style lang="scss">
  .user-preview {
    display: flex;
    align-items: center;
  
    &__avatar {
      width: 50px;
      height: 50px;
      overflow: hidden;
      border-radius: 50%;
      margin-right: 16px;
      position: relative;
    }
  
    &__avatar-overlay {
      @include flex-center;
      position: absolute;
      background-color: $text;
      transform: translate3d(-100%, 0, 0);
      transition: all 0.2s;
      opacity: 0.8;
  
      @include full-bg;
  
      svg {
        stroke: #fff;
      }
    }
  
    &__avatar:hover {
      .user-preview__avatar-overlay {
        transform: translate3d(0, 0, 0);
      }
    }
  
    &__name {
      font-weight: 700;
      font-size: 20px;
      line-height: 30px;
  
      span + span {
        margin-left: 8px;
      }
    }
  
    a {
      text-decoration: none;
      color: $text;
    }
  }
  </style>
  